import { jsonrepair } from "jsonrepair";

/**
 * A resilient JSON parser that attempts to parse JSON with repair if needed:
 * 1. Standard JSON.parse
 * 2. JSON repair using jsonrepair if standard parse fails
 */
export const parseJson = (content: string) => {
  if (!content) {
    return null;
  }

  try {
    // First try standard JSON.parse
    return JSON.parse(content);
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.warn(`Standard JSON parse failed: ${error}.`);
    }
    // Try to repair the JSON
    const repaired = jsonrepair(content);
    return JSON.parse(repaired);
  }
};
